













































import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import ClippingImage from '@/components/ClippingImage.vue'
import common from '@/common'

@Component({
    components: {
        ClippingImage,
    },
})
export default class UploadImg extends Vue {
    $refs!: {
        upload: any
    }

    @Prop({default: 'auto'}) height!: string

    @Prop({default: 10}) fileSize!: number

    @Prop({default: '/peanut/common/resource/icon/upload'}) action!: any

    @Prop({
        default() {
            return {}
        }}) paramsData!: any

    @Prop({
        default() {
            return {}
        }}) headers!: any

    @Prop({default: ''}) value!: any                // 只能上传一张图片时可以传字符串或数组，多张传数组

    @Prop({default: false}) multi!: boolean         // 是否为多张图片

    @Prop({default: false}) disabled!: boolean      // 是否禁用

    @Prop({default: 1}) limit!: number              // 默认只能上传一张图片

    @Prop({default: false}) multipleImage!: boolean

    @Prop({default: false}) clipping!: boolean

    @Prop({
        default() {
            return [3, 4]
        },
    }) fixedNumber!: any[]

    @Prop({
        default() {
            return [300, 400]
        },
    }) autoCropSize!: any[]

    @Prop({default: false}) noAnimation!: boolean  // 是否需要动画

    dialogImageUrl: string = ''

    dialogVisible: boolean = false

    clippingVisible: boolean = false

    clippingFile: any = ''

    originalFile: any = ''

    fileList: any = ''

    fileIndex: number = -1      // 当前操作的文件在fileList中的index

    lastFileList: any[] = []    // 最新的文件列表

    uploading: boolean = false // 上传中

    get photoList(): any {
        if (this.fileIndex > -1) {
            this.fileIndex = -1
            return this.lastFileList
        }
        if (this.multi) {
            return this.value.map(item => ({url: common.getCompleteUrl(item)}))
        }
        return this.value ? [{
            url: common.getCompleteUrl(this.value),
        }] : []
    }

    set photoList(val: any) {
        if (this.multi) {
            val = val.map(item => common.getRelativeUrl(item.url))
        } else {
            val = val.length ? common.getRelativeUrl(val[0].url) : ''
        }
        this.$emit('input', val)
    }

    async beforeHandleRemove(file, fileList) {
        const res = await this.$confirm('Confirm to delete?', '', {
            confirmButtonText: this.$t1('confirm'),
            cancelButtonText: this.$t1('cancel'),
            type: 'warning',
        })
        return res === 'confirm'
    }


    handleRemove(file, fileList) {
        this.fileIndex = this.lastFileList.indexOf(file)
        this.lastFileList = fileList
        this.photoList = fileList
        this.$emit('remove', fileList)
    }

    handlePreview(file) {
        // console.log('handlePreview')
        this.dialogImageUrl = file.url
        this.dialogVisible = true
    }

    handleBeforeUpload(file) {
        // console.log('handleBeforeUpload')
        if (!this.clipping && file.size > this.fileSize * 1024 * 1024) {
            return this.$message.warning(`${this.$t1('images_size_must_be_up_to')} ${ this.fileSize }M!`)
            // this.$refs.upload.clearFiles()
        }
        this.uploading = true
    }

    handleSuccess(response, file, fileList) {
        if (+response.code === 200) {
            let index = fileList.indexOf(file)
            this.lastFileList = fileList
            this.fileIndex = index
            fileList[index].url = common.getCompleteUrl(response.data)
            this.photoList = fileList
            this.$emit('change', fileList)
        }
        this.uploading = false
    }

    handleError(err, file, fileList) {
        this.$message.error(err.message || 'System Error')
        this.uploading = false
    }

    handleProgress(event, file, fileList) {
    }

    handleChange(file, fileList) {
        this.fileList = fileList
        if (this.clipping && fileList.indexOf(file) > -1 && this.originalFile !== file) {
            this.originalFile = file
            this.clippingFile = window.URL.createObjectURL(file.raw)
            this.clippingVisible = true
        }
    }

    clippingDone(file) {
        file.uid = this.originalFile.raw.uid
        this.originalFile.raw = file
        this.$refs.upload.submit()
    }

    clippingCancel() {
        this.photoList = []
    }
}
